/**
 * App Version Configuration
 * این فایل توسط اسکریپت update-version.sh آپدیت می‌شود
 */
export const APP_VERSION = '1.3.9'
export const APP_BUILD = '139'

export default {
  version: APP_VERSION,
  build: APP_BUILD,
  full: `${APP_VERSION} (${APP_BUILD})`,
}
